/**
 * Create a cache tag for RTK-Query.
 * @private
 * @category Cache Tags
 */
export const createTag = (type, ...keys) => ({
    type: type,
    id: keys.join('_').toLowerCase(),
});
// Order of address priorities if all present:
// 1. SuperToken Address
// 2. Publisher / Sender / From Address
// 3. Subscriber / Receiver / To Address
//# sourceMappingURL=CacheTagTypes.js.map